import React from 'react'
import './VeyetalsCard.scss'

export default function VeyetalsCard({ vital, value, unit, icon, color }) {
  return (
    <div className='veyetals-card'>
      <div className='veyetals-card__container'>
        {icon}
        <p className='veyetals-card__title' style={{ color: `${color}` }}>
          {vital}
        </p>
      </div>
      <div className='veyetals-card__reading'>
        <p className='veyetals-card__value'>{value}</p>
        {!isNaN(value) && <p className='veyetals-card__unit'>{unit}</p>}
      </div>
    </div>
  )
}
